var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{ref:"camera",attrs:{"id":"camera"}},[_c('js-camera',{ref:"js-camera",attrs:{"id":"js-camera","audio":"false","facing":"back"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }